<div class="container-fluid">
    <h1 class="m-3 display-6 vm-container-header"><i class="bi bi-clock-history me-2"></i> Processing Request History</h1>

    <div class="pb-5">
        <div class="m-3 p-3 bg-body-light rounded-3 shadow">
            <form [formGroup]="form" (ngSubmit)="search()" autocomplete="off">
                <div class="row g-2">
                    <div class="col-12 col-sm-6 col-lg-3">
                        <div class="form-floating">
                            <select class="form-select" id="requestType" formControlName="requestType">
                                <option value="">All</option>
                                <option value="BACKOUT">Backout</option>
                                <option value="REPROCESSING">Reprocessing</option>
                            </select>
                            <label for="requestType">Request type</label>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <div class="form-floating">
                            <select class="form-select" id="fileType" formControlName="fileType">
                                <option value="">All</option>
                                <option value="852">852</option>
                                <option value="867">867</option>
                            </select>
                            <label for="fileType">File type</label>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <div class="form-floating">
                            <select class="form-select" id="status" formControlName="status">
                                <option value="">All</option>
                                <option value="QUEUED">Queued</option>
                                <option value="IN_PROGRESS">In progress</option>
                                <option value="COMPLETE">Complete</option>
                            </select>
                            <label for="status">Status</label>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <div class="form-floating">
                            <select class="form-select" id="customerId" formControlName="customerId">
                                <option value="">All customers</option>
                                @for (customer of customers; track customer.id) {
                                    <option [value]="customer.id">{{ customer.name }}</option>
                                }
                            </select>
                            <label for="customerId">Customer</label>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <div class="input-group">
                            <div class="form-floating">
                                <input class="form-control" id="from" formControlName="from"
                                       ngbDatepicker #from="ngbDatepicker" (click)="from.toggle()">
                                <label for="from">From</label>
                            </div>
                            <i class="bi bi-calendar vm-icon input-group-text" (click)="from.toggle()"></i>
                        </div>
                        @if (isControlInvalid(form.controls.from)) {
                            <div class="text-danger small mt-1">Enter a valid date.</div>
                        }
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <div class="input-group">
                            <div class="form-floating">
                                <input class="form-control" id="to" formControlName="to"
                                       ngbDatepicker #to="ngbDatepicker" (click)="to.toggle()">
                                <label for="to">To</label>
                            </div>
                            <i class="bi bi-calendar vm-icon input-group-text" (click)="to.toggle()"></i>
                        </div>
                        @if (isControlInvalid(form.controls.to)) {
                            <div class="text-danger small mt-1">Enter a valid date.</div>
                        }
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <div class="form-floating">
                            <input class="form-control" id="fileName" formControlName="fileName" type="text" placeholder="File name contains">
                            <label for="fileName">File name contains</label>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <div class="form-floating">
                            <input class="form-control" id="requestedBy" formControlName="requestedBy" type="text" placeholder="Requested by contains">
                            <label for="requestedBy">Requested by contains</label>
                        </div>
                    </div>
                    <div class="col-12 d-flex justify-content-end gap-2">
                        <button type="button" class="btn btn-outline-primary" (click)="reset()">
                            Reset (last 30 days)
                        </button>
                        <button type="submit" class="btn btn-primary">
                            <i class="bi bi-search me-1"></i> Search
                        </button>
                    </div>
                </div>
            </form>
        </div>

        @if (fileGuid()) {
            <div class="mx-3 alert alert-info py-2 d-flex justify-content-between align-items-center">
                <span><i class="bi bi-info-circle-fill me-2"></i>Showing the full history for one file: <code>{{ fileGuid() }}</code></span>
                <a href="#" (click)="showAllRequests(); $event.preventDefault()">Show all requests</a>
            </div>
        }

        <div class="mx-3 d-flex justify-content-between align-items-center">
            <span class="text-body-secondary">{{ items().length }} Total</span>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="exportCsv()">
                <i class="bi bi-download me-1"></i> Export CSV
            </button>
        </div>

        <div class="mx-3">
            @for (group of groups(); track group.key) {
                <div class="fw-semibold text-body-secondary mt-4 mb-2">{{ group.heading }}</div>

                @for (item of group.items; track item.requestType + item.fileGuid + item.createdAt) {
                    <div class="callout mb-2"
                         [class.callout-danger]="item.requestType === 'BACKOUT'"
                         [class.callout-dark]="item.requestType === 'REPROCESSING'">
                        <div class="d-flex justify-content-between flex-wrap gap-2">
                            <span class="fw-semibold"
                                    [class.text-danger]="item.requestType === 'BACKOUT'"
                                    [class.text-dark]="item.requestType === 'REPROCESSING'">
                                <i class="bi me-1"
                                    [class.bi-trash3]="item.requestType === 'BACKOUT'"
                                    [class.bi-arrow-repeat]="item.requestType === 'REPROCESSING'"></i>
                                {{ item.requestType === 'BACKOUT' ? 'Backout' : 'Reprocessing' }}
                                <span class="fw-normal text-body">
                                    <i class="bi bi-chevron-compact-right"></i>
                                    @if (item.customerName) {
                                        <span>{{ item.customerName }}</span>
                                    } @else {
                                        <span class="fst-italic">Customer not recorded</span>
                                    }
                                    <i class="bi bi-chevron-compact-right"></i>
                                    <span>{{ item.fileType }}</span>
                                </span>
                            </span>
                            <span>
                                <span class="badge"
                                        [class.text-bg-secondary]="item.status === 'QUEUED'"
                                        [class.text-bg-primary]="item.status === 'IN_PROGRESS'"
                                        [class.text-bg-success]="item.status === 'COMPLETE'">{{ item.status }}</span>
                                @if (isStuck(item)) {
                                    <span class="badge text-bg-danger ms-1">Possibly stuck</span>
                                }
                            </span>
                        </div>

                        <div class="w-100 mt-1 file-name">{{ item.fileName || 'File name not recorded' }}</div>

                        <div class="small text-body-secondary d-flex flex-wrap column-gap-4 mt-1">
                            <span>{{ formatDateTime(item.createdAt) }}</span>
                            <span>by {{ item.requestedBy || 'unknown' }}</span>
                            <code>{{ item.fileGuid }}</code>
                        </div>
                    </div>
                }
            } @empty {
                <div class="card text-center bg-warning-subtle border border-warning rounded p-3 m-5">
                    <div class="card-body">
                        <i class="bi bi-exclamation-triangle-fill me-2"></i>
                        @if (loadFailed()) {
                            The request history could not be loaded.
                            <div><button type="button" (click)="search()" class="btn btn-primary mt-3">Try again</button></div>
                        } @else {
                            No requests match these filters.
                            <div><a href="#" (click)="reset(); $event.preventDefault()" class="btn btn-primary mt-3">Clear filters</a></div>
                        }
                    </div>
                </div>
            }
        </div>

        @if (items().length > pageSize) {
            <div class="d-flex justify-content-center mt-3">
                <ngb-pagination [collectionSize]="items().length" [pageSize]="pageSize"
                                [page]="page()" (pageChange)="page.set($event)" [maxSize]="7"
                                [boundaryLinks]="true"></ngb-pagination>
            </div>
        }
    </div>
</div>
